import ContentHubs from './ContentHubs'

export default ContentHubs
